import { render, staticRenderFns } from "./resend-activation.vue?vue&type=template&id=6b444ae2&scoped=true"
import script from "./resend-activation.vue?vue&type=script&lang=js"
export * from "./resend-activation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b444ae2",
  null
  
)

export default component.exports